import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Auth is handled via the HttpOnly `session_token` cookie set by the backend
// on Google OAuth callback. `withCredentials: true` sends it on every request.
// No client-side token storage is needed — this eliminates a common XSS
// exfiltration path (localStorage is JS-readable, HttpOnly cookies are not).
export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});
